export const ATTRIBUTE_MAPPING_ALL = 'ATTRIBUTE_MAPPING_ALL';
export const ATTRIBUTE_MAPPING_SINGLE = 'ATTRIBUTE_MAPPING_SINGLE';
export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
